// GBRRules.js
import React from "react";

const GBRRules = () => {
  return (
    <div className="gbr-rules">
      <br></br>
      <h1 className="heading-15" style={{fontSize:24}}><b>GBR Rules</b></h1>
      <br></br>
      <p className="paragraph-2">
        <strong>🎟 Earning Tickets</strong>
        <br />
        - Tickets are awarded for each advert that is completed and confirmed by
        our third-party advert providers.
        <br />
        - Additional tickets can be earned by referring friends using your
        in-game referral code.
        <br />
        - A maximum of <strong>200 tickets</strong> can be earned per person
        each day.
        <br />
        <br />
        <strong>🕛 The Daily Draw</strong>
        <br />
        - The draw takes place daily at <strong>12:00 UTC</strong>.
        <br />
        - 100 winners are randomly selected each day and awarded a prize from
        the prize structure below.
        <br />
        - Players can choose to receive their prize as either a{" "}
        <strong>Gift Card, Paypal</strong> or{" "}
        <strong>Cryptocurrency</strong> (Kepithor Token - KEPI).
        <br />
        - While we have withdrawal options for as little as £0.10 (such as
        Amazon Gift Cards), some withdrawal options may impose a higher minimum
        withdrawal amount.
        <em>
          <br />-{" "}
        </em>
        If the prize is claimed as a gift card, the winner will be able to
        choose from a wide selection tailored to their location.{" "}
        <strong>UK winners</strong> can choose from{" "}
        <strong>over 100 different gift cards</strong>, including Amazon, Tesco,
        and Google Play.
        <br />
        <br />
        <strong>
          💰 Daily Prizes (Currently £25 Prize Pool)
          <br />
          - 1st: £5.
          <br />
          - 2nd to 10th: £1.
          <br />
          - 11th to 30th: £0.20.
          <br />
          - 31st to 100th: £0.10.
          <br />
          <br />
          As the game grows, the prize pool will also increase, which will mean
          either bigger prizes or more prizes.
          <br />
          <br />
          ℹ️ More Info
        </strong>
        <br />
        For questions or to find out what gift cards are available in your
        region, please contact us at{" "}
        <a href="mailto:team@kepithorstudios.com">
          <strong>team@kepithorstudios.com</strong>
        </a>
        .
      </p>
    </div>
  );
};

export default GBRRules;
